import PropTypes from 'prop-types'

import { userDetailsPropType } from '../../users/prop-types'

import brandPropType from './brand-prop-type'

const brandCurationTaskPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  taskStatus: PropTypes.string.isRequired,
  awaitingStatus: PropTypes.string.isRequired,
  problemReason: PropTypes.string,
  brand: brandPropType.isRequired,
  assignedCurator: PropTypes.object,
  assignedQa: PropTypes.object,
  assignedQc: PropTypes.object,
  isDeleted: PropTypes.bool,
  isReopenedManually: PropTypes.bool,
  reopenedBy: userDetailsPropType,
  createdBy: userDetailsPropType,
  updatedBy: userDetailsPropType,
  curatedBy: userDetailsPropType,
  updatedAt: PropTypes.string,
  createdAt: PropTypes.string,
  reopenedAt: PropTypes.string,
  curatedAt: PropTypes.string,
  qadAt: PropTypes.string,
  qcdAt: PropTypes.string,
})

brandCurationTaskPropType.defaultProps = {
  problemReason: undefined,
  assignedCurator: undefined,
  assignedQa: undefined,
  assignedQc: undefined,
  isDeleted: undefined,
  isReopenedManually: undefined,
  reopenedBy: undefined,
  createdBy: undefined,
  updatedBy: undefined,
  curatedBy: undefined,
  updatedAt: undefined,
  createdAt: undefined,
  reopenedAt: undefined,
  curatedAt: undefined,
  qadAt: undefined,
  qcdAt: undefined,
}

export default brandCurationTaskPropType
